import * as PIXI from 'pixi.js';

import InnerDropArea from './InnerDropArea';
import constants from '../settings/constants';
import geometry from './util/geometry';
import DynamicProppingAncestor from './DynamicProppingAncestor';
import { getProppingBounds } from '../services/products/models';
import productService from '../services/products';
import { config as asConfig } from './boaxel/AdjustableConfig';
import adjustableContainer from './util/adjustableContainer';
import { ITEMS } from '../constants';

export default class Shelf extends DynamicProppingAncestor {
  setSpriteVisibilities() {
    if (this.sprite) {
      this.sprite.visible = !this.isExtendable;
    }
    if (this.adjustableContainer) {
      this.adjustableContainer.visible = this.isExtendable;
    }
  }

  drawAdjustable() {
    this.adjustableContainer = adjustableContainer(
      this.adjustableContainer,
      this.data.outerSize,
      asConfig.shelf[this.item.id],
      this.ratio
    );

    if (!this.adjustableContainer.parent) {
      // Put it between the brackets
      this.addChildAt(
        this.adjustableContainer,
        this.children.indexOf(this.sprite)
      );
    }
  }

  draw() {
    const { scaledVertices } = this.data;
    this.bottomContainer = this.bottomContainer || new PIXI.Container();
    this.bottomContainer.x = scaledVertices[4][0] - scaledVertices[0][0];

    if (!this.bottomContainer.parent) {
      this.addChild(this.bottomContainer);
    }

    super.draw();

    if (this.isExtendable) {
      this.drawAdjustable();
    }

    this.setSpriteVisibilities();
  }

  getContainer(sprite) {
    return this.bottomContainer;
  }

  update(args) {
    this.isExtendable = productService.isExtendable(args.item);

    super.update(args);

    // this extra update should only occur on load,
    // and is needed since we don't have the adjusted width in pac.
    if (this.isExtendable) {
      const item = this.item;
      const parent = this.parentItem;
      const parentLogic = parent.id ? parent.logic : this.item.logic;

      if (parent && item.width !== parent.width) {
        if (productService.isExtendable(parentLogic)) {
          const newItem = { ...item, width: parent.width };
          this.app.updateItem(newItem, parent, {
            automatedUpdate: true,
          });
        }
      }
    }
  }

  getBounds() {
    const bounds = super.getBounds();
    if (this.item.items && this.item.items.length > 0) {
      const clothesRail = this.item.items.find(item =>
        productService.isType(item, ITEMS.CLOTHES_RAIL)
      );
      if (clothesRail) {
        const proppingItem = productService.isExtendable(clothesRail)
          ? productService.getProduct(
              asConfig.clothesrail[clothesRail.id].rightId
            )
          : clothesRail;
        const paddingBottom = 10;
        const shelfHeight = this.item.height * this.ratio;
        const smallestProppingHeight =
          getProppingBounds(proppingItem)[0].size.height * this.ratio;

        bounds.height = shelfHeight + smallestProppingHeight + paddingBottom;
      }
    }
    return bounds;
  }

  getSelfHitArea() {
    const { scaledVertices } = this.data;
    // the 4 is a "magical" number that created hit areas that touch (or very
    // slightly overlap) when two shelves are placed in adjacent connections
    const padding = (constants.DISTANCE_BETWEEN_ATTACHMENTS / 4) * this.ratio;

    const vertices = [
      [scaledVertices[0][0], scaledVertices[0][1] + padding],
      [scaledVertices[3][0], scaledVertices[3][1]],
      [scaledVertices[7][0], scaledVertices[7][1] - padding],
      [scaledVertices[6][0], scaledVertices[6][1] - padding],
      [scaledVertices[5][0], scaledVertices[5][1]],
      [scaledVertices[1][0], scaledVertices[1][1] + padding],
    ];

    return {
      regions: [vertices],
    };
  }

  getAllChildren() {
    return super.getAllChildren().concat(this.bottomContainer.children);
  }

  getDropAreaSprite(localSlot) {
    const localItem = {
      ...this.item,
      x: 0,
      y: 0,
    };
    if (
      geometry.collides(localSlot, localItem, {
        top: 50,
        bottom: 50,
      })
    ) {
      const sprite = new InnerDropArea({
        width: localSlot.width * this.ratio,
        height: localSlot.height * this.ratio,
        ratio: this.ratio,
        slot: localSlot,
      });

      sprite.slot = localSlot;

      sprite.x = 0;
      sprite.y = (this.item.height - localSlot.y) * this.ratio;

      return sprite;
    }
  }
}
